"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checked = void 0;
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = __importStar(require("react-native-svg"));
function Checked({ size = 20, color = '#3db384', background = true, }) {
    return (react_1.default.createElement(react_native_svg_1.default, { width: size, height: size, viewBox: "0 0 32 32" },
        background && react_1.default.createElement(react_native_svg_1.Rect, { width: "32", height: "32", rx: "4", fill: "#efefee" }),
        react_1.default.createElement(react_native_svg_1.Path, { d: "M14.12,23.52l-7-6.68a1,1,0,0,1,0-1.34,1,1,0,0,1,1.35,0l5.51,5.25L23.1,9.11A.94.94,0,0,1,24.43,9a1,1,0,0,1,.16,1.34Z", fill: color })));
}
exports.Checked = Checked;
